import { createStore, combineReducers } from "redux";

import { currentScoreReducer } from "./currentScore";
import { currentLevelReducer } from "./currentLevel";
import Auth from "./auth/reducer";

export default createStore(combineReducers({ currentScoreReducer, currentLevelReducer, Auth }));
